import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { condicion_pago } from '../../shared/object/condicion_pago.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SecurityService } from '../../shared/services/security.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { condicion_pago_sii } from 'src/app/shared/object/condicion_pago_sii.model';

@Component({
  selector: 'app-condipag',
  templateUrl: './condipag.component.html',
  styleUrls: ['./condipag.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class CondipagComponent implements OnInit {
  private client: GraphQLClient = null;
  condipagList: condicion_pago[];
  selectedCondipag: condicion_pago;
  condipag: condicion_pago;
  public radioModel: string = 'Left';

  public busquedaEstado;

  public rut_empresa;
  public sucursal_codigo;

  public formAgregarCondicionPago: FormGroup;
  public formEditarCondicionPago: FormGroup;
  listacpSII: condicion_pago_sii[];

  optionsCondicionPagoSII: Array<any> = [];


  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 12;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService 
  ) {
    this.client = client;
    this.formAgregarCondicionPago = this.construyeFormAgrega();
    this.formEditarCondicionPago = this.construyeFormEdita();
    this.busquedaEstado = 1;
  }
  filtraxEstado() {
    this.obtenerDatosCondicionPago(
      Number(this.rut_empresa),
      Number(this.sucursal_codigo)
    );
  }
  muestraModalAgrega() {
    this.selectedCondipag = {
      rut_empresa: null,
      sucursal_codigo: null,
      codigo: null,
      descripcion: '',
      estado: true,
      cantidad_dias: null,
      recargoporc: 0,
      uso_compra: null,
      uso_venta: null,
      condicion_pago_sii_codigo: 1
    };
    this.formAgregarCondicionPago.reset();
    // Desconozco porque al hacer reset en Recargo me deja vacío en vez del valor inicial cero, por eso puse setValue
    this.frmAgregaRecargoPorc.setValue(0);
  }

  /***************Construccion de formularios reactivos****************/
  construyeFormAgrega() {
    return new FormGroup({
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(100),
      ]),
      cantidadDias: new FormControl('', [
        Validators.required,
        Validators.min(0),
        Validators.max(365),
      ]),
      recargoPorc: new FormControl({ value: 0}, [
        Validators.min(0),
        Validators.max(99),
        Validators.required,
      ]),
      estado: new FormControl(true),
      usoVenta: new FormControl(true),
      usoCompra: new FormControl(true),
      condipagsii: new FormControl({value:'1'}, [Validators.required])
    });
  }

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl({ value: '', disabled: true }),
      empresa_rut: new FormControl(''),
      sucursal_codigo: new FormControl(''),
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(100),
      ]),
      cantidadDias: new FormControl({ value: '', disabled: true }),
      recargoPorc: new FormControl('0', [
        Validators.min(0),
        Validators.max(99),]),
      estado: new FormControl(true),
      usoVenta: new FormControl({ value: true, disabled: true }),
      usoCompra: new FormControl({ value: true, disabled: true }),
      condipagsii: new FormControl('1')
    });
  }
  /***************Fin de Construccion de formularios reactivos****************/
  ngOnInit() {
    this.selectedCondipag = {
      codigo: null,
      rut_empresa: null,
      sucursal_codigo: null,
      descripcion: '',
      cantidad_dias: null,
      uso_venta: null,
      uso_compra: null,
      estado: null,
      recargoporc: null,
      condicion_pago_sii_codigo: 1
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerDatosCondicionPago(
      Number(this.rut_empresa),
      Number(this.sucursal_codigo)
    );
    this.obtenerDatosCondiPagSII();
  }

  cambiaSII()
  {
    if (this.frmAgregaCantidadDias.value===0)
    {
      this.formAgregarCondicionPago.get('condipagsii').setValue(1);
    }
    else
    {
      this.formAgregarCondicionPago.get('condipagsii').setValue(2);
    }
  }
 
  get frmAgregaDescripcion() {
    return this.formAgregarCondicionPago.get('descripcion');
  }
  get frmAgregaCantidadDias() {
    return this.formAgregarCondicionPago.get('cantidadDias');
  }
  get frmAgregaEstado() {
    return this.formAgregarCondicionPago.get('estado');
  }
  get frmAgregaUsoVenta() {
    return this.formAgregarCondicionPago.get('usoVenta');
  }
  get frmAgregaUsoCompra() {
    return this.formAgregarCondicionPago.get('usoCompra');
  }
  get frmAgregaRecargoPorc() {
    return this.formAgregarCondicionPago.get('recargoPorc');
  }
  get frmAgregaCondicionPagoSII() {
    return this.formAgregarCondicionPago.get('condipagsii');
  }

  get frmEditarCodigo() {
    return this.formEditarCondicionPago.get('codigo');
  }
  get frmEditarRut_Empresa() {
    return this.formEditarCondicionPago.get('empresa_rut');
  }
  get frmEditarSucursal_Codigo() {
    return this.formEditarCondicionPago.get('sucursal_codigo');
  }
  get frmEditarDescripcion() {
    return this.formEditarCondicionPago.get('descripcion');
  }
  get frmEditarCantidadDias() {
    return this.formEditarCondicionPago.get('cantidadDias');
  }
  get frmEditarUsoVenta() {
    return this.formEditarCondicionPago.get('usoVenta');
  }
  get frmEditarUsoCompra() {
    return this.formEditarCondicionPago.get('usoCompra');
  }
  get frmEditarEstado() {
    return this.formEditarCondicionPago.get('estado');
  }
  get frmEditarRecargoPorc() {
    return this.formEditarCondicionPago.get('recargoPorc');
  }
  get frmEditarCondicionPagoSII() {
    return this.formEditarCondicionPago.get('condipagsii');
  }
  

  obtenerDatosCondicionPago(rut_empresa: number, sucursal_codigo: number) {
    let self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query(
            $rut_empresa: Decimal
            $sucursal_codigo: Decimal
            $tipobusqueda: Int
          ) {
            condicion_pago {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    rut_empresa: $rut_empresa
                    sucursal_codigo: $sucursal_codigo
                    tipobusqueda: $tipobusqueda
                  }
                }
              ) {
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    descripcion
                    cantidad_dias
                    uso_venta
                    uso_compra
                    estado
                    recargoporc
                    condicion_pago_sii_codigo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rut_empresa: rut_empresa,
          sucursal_codigo: sucursal_codigo,
          tipobusqueda: this.busquedaEstado,
        },
      },
      function (respuesta) {
        self.condipagList =
          respuesta.data.condicion_pago.obtenerSegunFiltro.respuesta.registros;
      }
    );
  }

  showForEdit(con: condicion_pago) {
    this.formEditarCondicionPago.reset();
    this.selectedCondipag = Object.assign({}, con);
    this.frmEditarRut_Empresa.setValue(con.rut_empresa);
    this.frmEditarSucursal_Codigo.setValue(con.sucursal_codigo);
    this.frmEditarCodigo.setValue(con.codigo);
    this.frmEditarDescripcion.setValue(con.descripcion);
    this.frmEditarCantidadDias.setValue(con.cantidad_dias);
    this.frmEditarEstado.setValue(con.estado);
    this.frmEditarUsoCompra.setValue(con.uso_compra);
    this.frmEditarUsoVenta.setValue(con.uso_venta);
    this.frmEditarRecargoPorc.setValue(con.recargoporc);
    this.frmEditarCondicionPagoSII.setValue(con.condicion_pago_sii_codigo);
  }

  insertar() {
    this.condipag = {
      codigo: 0,
      rut_empresa: Number(this.rut_empresa),
      sucursal_codigo: Number(this.sucursal_codigo),
      descripcion: this.frmAgregaDescripcion.value,
      estado: this.frmAgregaEstado.value,
      cantidad_dias: this.frmAgregaCantidadDias.value,
      uso_compra: this.frmAgregaUsoCompra.value,
      uso_venta: this.frmAgregaUsoVenta.value,
      recargoporc: this.frmAgregaRecargoPorc.value,
      condicion_pago_sii_codigo: this.frmAgregaCondicionPagoSII.value
    };
    this.postCondipag(this.condipag);
  }

  postCondipag(cond: condicion_pago) {
    let self = this;
    var bodyx = cond;

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: condicion_pagoInputType) {
            condicion_pago {
              agregar(entidad: $entidad) {
                respuesta {
                  codigo
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        setTimeout(
          () =>
            self.obtenerDatosCondicionPago(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }

  actualizar() {
    this.condipag = {
      codigo: this.frmEditarCodigo.value,
      descripcion: this.frmEditarDescripcion.value,
      estado: this.frmEditarEstado.value,
      rut_empresa: this.frmEditarRut_Empresa.value,
      sucursal_codigo: this.frmEditarSucursal_Codigo.value,
      uso_compra: this.frmEditarUsoCompra.value,
      uso_venta: this.frmEditarUsoVenta.value,
      cantidad_dias: this.frmEditarCantidadDias.value,
      recargoporc: this.frmEditarRecargoPorc.value,
      condicion_pago_sii_codigo: this.frmEditarCondicionPagoSII.value
    };

    this.refrescar(this.condipag);
  }

  cambiaEstado(condiPagSeleccionada: condicion_pago) {
    if (condiPagSeleccionada.estado) {
      condiPagSeleccionada.estado = false;
    } else {
      condiPagSeleccionada.estado = true;
    }
    this.refrescar(condiPagSeleccionada);
  }

  refrescar(cond: condicion_pago) {
    let self = this;
    var bodyx = cond;
    delete cond['__typename'];

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: condicion_pagoInputType) {
            condicion_pago {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  sucursal_codigo
                  rut_empresa
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
       function (respuesta) {
        if (respuesta.data.condicion_pago.guardar.respuesta == null) {
          if (respuesta.data.condicion_pago.guardar.mensajes.length > 0) {
            alert(respuesta.data.condicion_pago.guardar.mensajes[0].texto);
          }
        }
        setTimeout(
          () =>
            self.obtenerDatosCondicionPago(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }
  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  
  obtenerDatosCondiPagSII() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query
          {
            condicion_pago_sii
            {
              obtenerTodos{
                mensajes
                {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
                {
                  registros
                  {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listacpSII =
          respuesta.data.condicion_pago_sii.obtenerTodos.respuesta.registros;
        self.optionsCondicionPagoSII = [];
        let sel: any;
        self.listacpSII.forEach((element) => {
          sel = { value: element.codigo, label: element.descripcion };
          self.optionsCondicionPagoSII.push(sel);
        });
      }
    );
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(condiPagSeleccionada: condicion_pago) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(condiPagSeleccionada);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
